import { StandardEvents } from '@shopify/events';

const INSTALL_KEY = '__veloctexVariantCheckoutSyncInstalled';

if (!window[INSTALL_KEY]) {
  window[INSTALL_KEY] = true;

  const generations = new WeakMap();

  document.addEventListener(StandardEvents.productSelect, async (event) => {
    const picker = event.target;
    if (!(picker instanceof HTMLElement) || !event.promise) return;

    const scope = picker.closest('.shopify-section, dialog, product-card');
    if (!scope) return;

    const productId = picker.dataset.productId;
    const forms = Array.from(scope.querySelectorAll('product-form-component'));
    const productForm =
      forms.find((form) => !productId || form.dataset.productId === productId) ||
      (forms.length === 1 ? forms[0] : null);

    if (!(productForm instanceof HTMLElement)) return;

    const generation = (generations.get(productForm) || 0) + 1;
    generations.set(productForm, generation);

    const lockCheckout = () => {
      const checkout = productForm.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (!(checkout instanceof HTMLElement)) return;
      checkout.setAttribute('aria-busy', 'true');
      checkout.setAttribute('inert', '');
      checkout.style.pointerEvents = 'none';
    };

    const unlockCheckout = () => {
      const checkout = productForm.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (!(checkout instanceof HTMLElement)) return;
      checkout.removeAttribute('aria-busy');
      checkout.removeAttribute('inert');
      checkout.style.pointerEvents = '';
    };

    lockCheckout();

    try {
      const result = await event.promise;
      if (generations.get(productForm) !== generation) return;

      const detail = result?.detail;
      const html = detail?.html;
      const resource = detail?.resource;
      if (!html?.querySelector) return;

      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput instanceof HTMLInputElement) {
        const resolvedVariantId = resource?.id != null ? String(resource.id) : '';
        variantInput.value = resolvedVariantId;
        variantInput.setAttribute('value', resolvedVariantId);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const currentForm = productForm.querySelector('form[data-type="add-to-cart-form"]');
      const currentFormId = currentForm instanceof HTMLFormElement ? currentForm.id : '';

      let responseProductForm = null;
      if (currentFormId) {
        const responseForm = html.getElementById?.(currentFormId);
        responseProductForm = responseForm?.closest('product-form-component') || null;
      }

      if (!responseProductForm) {
        const responseProductId = detail?.newProduct?.id || detail?.productId || productForm.dataset.productId || '';
        responseProductForm = responseProductId
          ? html.querySelector(`product-form-component[data-product-id="${CSS.escape(String(responseProductId))}"]`)
          : html.querySelector('product-form-component');
      }

      const freshCheckout = responseProductForm?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      const currentCheckout = productForm.querySelector('[ref="acceleratedCheckoutButtonContainer"]');

      if (resource && resource.available !== false && freshCheckout instanceof HTMLElement) {
        const replacement = freshCheckout.cloneNode(true);

        if (currentCheckout instanceof HTMLElement) {
          currentCheckout.replaceWith(replacement);
        } else {
          productForm.querySelector('.product-form-buttons')?.appendChild(replacement);
        }

        window.Shopify?.PaymentButton?.init?.();
      } else if (currentCheckout instanceof HTMLElement) {
        currentCheckout.setAttribute('hidden', 'true');
      }
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.warn('[VELOCTEX] Variant checkout synchronization failed:', error);
      }
    } finally {
      if (generations.get(productForm) === generation) {
        unlockCheckout();
      }
    }
  });
}
